module.exports = __webpack_public_path__ + "static/media/clothes.a8807984.jpg";